import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { IUserResponse } from '../../interfaces/user.interface';
import { StorageService } from "../../../../core/services/storage/storage.service";

export const salonOwnerGuard: CanActivateFn = (_route, _state) => {
  const router: Router = inject(Router);
  const storageService = inject(StorageService);
  const platformId = inject(PLATFORM_ID);

  const user: IUserResponse | null = storageService.getObject<IUserResponse>('USER');

  if (!user || user.user_type !== 'salon_owner') {
    if (isPlatformBrowser(platformId)) {
      router.navigate(['/home']).then();
    }
    return false;
  }
  return true;
};
